import { render, staticRenderFns } from "./FlagSwitcher.vue?vue&type=template&id=f66a1234&scoped=true"
import script from "./FlagSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlagSwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FlagSwitcher.vue?vue&type=style&index=0&id=f66a1234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66a1234",
  null
  
)

export default component.exports